import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { Collapse, ListItemButton, ListItemText } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { groupContainsPath } from '../../utils/page';
import { NavListItem } from './NavListItem';

export const NavCollapse = ({ title, subPages, pageStatus, onNavigate }) => {
	const { pathname } = useLocation();
	const containsCurrentPage = groupContainsPath(subPages, pathname);
	const [open, setOpen] = useState(containsCurrentPage);

	// Arriving at a page (by link, bookmark or refresh) reveals its group; other groups keep whatever the user chose.
	useEffect(() => {
		if (containsCurrentPage) setOpen(true);
	}, [containsCurrentPage]);

	return (
		<>
			<ListItemButton onClick={() => setOpen((value) => !value)}>
				<ListItemText primary={title} />
				{open ? <ExpandLess /> : <ExpandMore />}
			</ListItemButton>
			<Collapse in={open} timeout="auto">
				{Object.keys(subPages).map((key) =>
					subPages[key].hideFromNav ? null : (
						<NavListItem
							key={key}
							path={key}
							text={subPages[key].title}
							status={pageStatus[key]}
							onNavigate={onNavigate}
							isSub
						/>
					)
				)}
			</Collapse>
		</>
	);
};

NavCollapse.propTypes = {
	title: PropTypes.string.isRequired,
	subPages: PropTypes.object,
	pageStatus: PropTypes.objectOf(PropTypes.string),
	onNavigate: PropTypes.func,
};

export default NavCollapse;
